export default "__VITE_ASSET__e4f77cd0__"